"use client";

import { c as _c } from "react/compiler-runtime";
import type { QueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { env } from "@/env";
import { QueryClientProvider } from "@tanstack/react-query";
import { createTRPCClient, httpLink, loggerLink } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import SuperJSON from "superjson";
import type { AppRouter } from "@hello/api";
import { api as legacyApi } from "@/lib/trpc/client";
import { createQueryClient } from "./query-client";
let clientQueryClientSingleton: QueryClient | undefined = undefined;
const getQueryClient = () => {
  if (typeof window === "undefined") {
    // Server: always make a new query client
    return createQueryClient();
  } else {
    // Browser: use singleton pattern to keep the same query client
    return clientQueryClientSingleton ??= createQueryClient();
  }
};
export const {
  useTRPC,
  TRPCProvider
} = createTRPCContext<AppRouter>();
export function TRPCReactProvider(props) {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getQueryClient();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queryClient = t0;
  const [trpcClient] = useState(_temp2);
  const [legacyTrpcClient] = useState(_temp4);
  let t1;
  if ($[1] !== props.children || $[2] !== trpcClient) {
    t1 = <QueryClientProvider client={queryClient}><TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>{props.children}</TRPCProvider></QueryClientProvider>;
    $[1] = props.children;
    $[2] = trpcClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== legacyTrpcClient || $[5] !== t1) {
    t2 = <legacyApi.Provider client={legacyTrpcClient} queryClient={queryClient}>{t1}</legacyApi.Provider>;
    $[4] = legacyTrpcClient;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp4() {
  return legacyApi.createClient({
    links: [loggerLink({
      enabled: _temp3
    }), httpLink({
      transformer: SuperJSON,
      url: getBaseUrl() + "/api/trpc",
      headers() {
        const headers_0 = new Headers();
        headers_0.set("x-trpc-source", "nextjs-react");
        return headers_0;
      }
    })]
  });
}
function _temp3(op_0) {
  return env.NODE_ENV === "development" || op_0.direction === "down" && op_0.result instanceof Error;
}
function _temp2() {
  return createTRPCClient({
    links: [loggerLink({
      enabled: _temp
    }), httpLink({
      transformer: SuperJSON,
      url: getBaseUrl() + "/api/trpc",
      headers() {
        const headers = new Headers();
        headers.set("x-trpc-source", "nextjs-react");
        return headers;
      }
    })]
  });
}
function _temp(op) {
  return env.NODE_ENV === "development" || op.direction === "down" && op.result instanceof Error;
}
const getBaseUrl = () => {
  // For client-side, always use the current origin
  if (typeof window !== "undefined") return window.location.origin;

  // In development mode, always use localhost
  if (env.NODE_ENV === "development") {
    // eslint-disable-next-line no-restricted-properties
    return `http://localhost:${process.env.PORT ?? 3000}`;
  }

  // Use NEXT_PUBLIC_API_URL if provided (for production/UAT)
  if (env.NEXT_PUBLIC_API_URL) return env.NEXT_PUBLIC_API_URL;

  // Use NEXT_PUBLIC_APP_URL as fallback
  if (process.env.NEXT_PUBLIC_APP_URL) return process.env.NEXT_PUBLIC_APP_URL;

  // Fallback to localhost
  // eslint-disable-next-line no-restricted-properties
  return `http://localhost:${process.env.PORT ?? 3000}`;
};